module.exports = __webpack_public_path__ + "img/banner-line_big_blue.f0eec4da.png";